import settings from './settings';
import axios from 'axios';

export async function exportMeasures(accessToken, deviceId, filter){
  return axios.get(settings.endpoints.exportMeasures(deviceId), {
    params: filter,
    responseType: 'arraybuffer',
    headers: {
      Authorization: accessToken
    }
  })
}

export async function exportMeasuresDevices(accessToken, filter){
  return axios.get(settings.endpoints.exportMeasuresDevices(), {
    params: filter,
    responseType: 'arraybuffer',
    headers: {
      Authorization: accessToken
    }
  })
}
